import request from '../request'

export default {
  smsCode(parameter) {
    return request({
      url: 'user/phoneverify',
      method: 'post',
      data: parameter,
    })
  },
  upload(parameter) {
    return request({
      url: 'api/fileupload',
      method: 'post',
      data: parameter,
    })
  },
}